module.exports = __webpack_public_path__ + "img/verse.18a629cb.png";